import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-programmation',
  templateUrl: './programmation.component.html',
  styleUrls: ['./programmation.component.css']
})
export class ProgrammationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
